import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams, useHistory } from "react-router-dom";
import Popup from "reactjs-popup";
import { set_sync_status } from "../../actions/Sync";
import { getSlotName } from "../../libs/SlotUtils";
import AddSlot from "../Slots/AddSlot";
import Expenses from "./ExpenseProject"
import stylelist from "stylelist";
import ExpenseBucketModule from "./ExpenseBucketModule";
import axios from "axios";
import SyncConstants from "../../constants/SyncConstants";
import useAuthentication from "../../hooks/useAuthentication";

const ExpensesPage = (props) => {

    const UserSettings = useSelector((state) => state.User);
    const ExpenseBucket = useSelector((state) => state.ExpenseBucket);
    const [showExpenseBucket, setShowExpenseBucket] = useState(false);
    const params = useParams();
    const history = useHistory();
    const Auth = useAuthentication();

    // State for breadcrumb
    const [breadcrumbPath, setBreadcrumbPath] = useState([]);

    // Calculate the root project ID based on URL or user settings
    const getRootProjectId = () => {
        if (params.id) {
            // Remove "-folders" suffix if present
            const cleanId = params.id.replace(/-folders$/, '');
            return parseInt(cleanId);
        }
        return UserSettings.currentExpenseProjectRootId;
    };

    const isDirectLink = params.id !== undefined;

    // State for the expense project ID
    const [expenseProjectId, setExpenseProjectId] = useState(getRootProjectId());

    // Load breadcrumb path when expenseProjectId changes
    useEffect(() => {
        if (isDirectLink) {
            loadBreadcrumb(expenseProjectId);
        } else {
            setBreadcrumbPath([]);
        }
    }, [expenseProjectId, isDirectLink]);

    const loadBreadcrumb = (projectId) => {
        axios({
            method: "get",
            auth: Auth.getAuthObject(),
            url: SyncConstants["syncBaseURL"] + "expenseProjects/byParent",
            params: {
                parent: projectId
            },
            responseType: 'json'
        }).then((response) => {
            if (response.data.parent && response.data.parent[0]) {
                const project = response.data.parent[0];
                // Build path from root to current project
                const path = [];
                
                // Add current project
                path.push({
                    id: project.id,
                    title: project.title,
                    project_type: project.project_type
                });

                // If project has a parent (not root), we need to traverse up
                if (project.parent && project.parent !== 0) {
                    loadParentBreadcrumb(project.parent, path);
                } else {
                    setBreadcrumbPath(path.reverse());
                }
            }
        }).catch(() => {
            setBreadcrumbPath([]);
        });
    };

    const loadParentBreadcrumb = (parentId, currentPath) => {
        axios({
            method: "get",
            auth: Auth.getAuthObject(),
            url: SyncConstants["syncBaseURL"] + "expenseProjects/byParent",
            params: {
                parent: parentId
            },
            responseType: 'json'
        }).then((response) => {
            if (response.data.parent && response.data.parent[0]) {
                const project = response.data.parent[0];
                currentPath.push({
                    id: project.id,
                    title: project.title,
                    project_type: project.project_type
                });

                if (project.parent && project.parent !== 0) {
                    loadParentBreadcrumb(project.parent, currentPath);
                } else {
                    setBreadcrumbPath(currentPath.reverse());
                }
            }
        }).catch(() => {
            setBreadcrumbPath(currentPath.reverse());
        });
    };

    // Update expenseProjectId when params.id changes
    useEffect(() => {
        const newRootId = getRootProjectId();
        setExpenseProjectId(newRootId);
    }, [params.id, UserSettings.currentExpenseProjectRootId]);

    const forceReload = () => {
        setExpenseProjectId(0);
        setTimeout(() => {
            setExpenseProjectId(getRootProjectId());
        }, 0);
    }

    const handleBackToStandardView = (e) => {
        e.preventDefault();
        history.push('/expenses');
    }

    return (
        <>
            <div className={stylelist(
                        [showExpenseBucket, "container-fluid ps-5 pe-5 mt-5"],
                        [!showExpenseBucket, "container mt-5"]
                    )}>

                    <div className="row">
                        <div className={stylelist(
                            [showExpenseBucket, "col-8"],
                            [!showExpenseBucket, "col-12"]
                        )}>
                       
                        <Expenses
                            key={expenseProjectId}
                            onProjectSelect={p => { debug(p) }}
                            expenseProjectId={expenseProjectId}
                            level="1"
                            filterDateFrom={false}
                            filterDateTo={false}
                            filterPerson={false}
                            selectMode={false}
                            onSelect={(e) => { console.log(e) }}
                            projectEditMode={false}
                            showArchivedProjects={false}
                            expenseBucket={showExpenseBucket}
                            setShowExpenseBucket={setShowExpenseBucket}
                            parentPath=""
                            isDirectLink={isDirectLink}
                            breadcrumb={isDirectLink && breadcrumbPath.length > 0 ? (
                                <>
                                    <a 
                                        href="#" 
                                        onClick={handleBackToStandardView} 
                                        className="badge bg-white text-dark border text-decoration-none me-1"
                                        style={{ fontSize: '0.875rem', padding: '0.5rem 0.75rem' }}
                                    >
                                        <i className="bi bi-house-door me-1"></i>
                                        Root
                                    </a>
                                    {breadcrumbPath.map((project, index) => {
                                        const isLast = index === breadcrumbPath.length - 1;
                                        const icon = project.project_type === 'customer' ? '👤' :
                                                    project.project_type === 'serviceproject' ? '🔧' : '📁';
                                        
                                        return (
                                            <React.Fragment key={project.id}>
                                                <i className="bi bi-chevron-right text-muted small"></i>
                                                {isLast ? (
                                                    <span 
                                                        className="badge bg-white text-dark border me-1"
                                                        style={{ 
                                                            fontSize: '0.875rem', 
                                                            padding: '0.5rem 0.75rem',
                                                            fontWeight: '600',
                                                            cursor: 'default'
                                                        }}
                                                    >
                                                        <span className="me-1">{icon}</span>
                                                        {project.title}
                                                    </span>
                                                ) : (
                                                    <a 
                                                        href={`/expenses/${project.id}-folders`}
                                                        className="badge bg-white text-dark border text-decoration-none me-1"
                                                        style={{ 
                                                            fontSize: '0.875rem', 
                                                            padding: '0.5rem 0.75rem',
                                                            transition: 'background-color 0.2s, box-shadow 0.2s'
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            e.target.style.backgroundColor = '#f8f9fa';
                                                            e.target.style.boxShadow = '0 0 0 2px rgba(13, 110, 253, 0.25)';
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            e.target.style.backgroundColor = '#ffffff';
                                                            e.target.style.boxShadow = '';
                                                        }}
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            history.push(`/expenses/${project.id}-folders`);
                                                        }}
                                                    >
                                                        <span className="me-1">{icon}</span>
                                                        {project.title}
                                                    </a>
                                                )}
                                            </React.Fragment>
                                        );
                                    })}
                                </>
                            ) : null}
                        />

                    </div>

                    {showExpenseBucket && 
                        <div className="col-4">
                            <h1>Expense-Bucket</h1>
                            <ExpenseBucketModule 
                                forceTreeReload={() => {forceReload()}}
                            />

                        </div>
                    }
                </div>

                <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
            </div>
        </>
    );
};

export default ExpensesPage;
